import { client } from '@hotjar/api-base-client';
import type { CustomerSummary } from '../common/model/customer-summary';

export const getCustomerSummary = async (accountId: number): Promise<CustomerSummary> =>
  client<Omit<CustomerSummary, 'accountId'>>({
    url: `/api/checkout/customers/${accountId}/summary`,
  }).then((customerSummary) => ({
    ...customerSummary,
    accountId,
  }));
